export default {
    "msg": {
        "8": "8",
        "20": "20",
        "250": "250",
        "Enter a new password": "Enter a new password",
        "which consists of uppercase letters, lowercase letters, numbers, and special characters, and includes at least 3 types": "which consists of uppercase letters, lowercase letters, numbers, and special characters, and includes at least 3 types",
        "Please enter the Confirmation Password": "Please enter the Confirmation Password",
        "the password is consistent with the new password": "the password is consistent with the new password",
        "Empty": "Empty",
        "No data": "No data",
        "List of update packages": "List of update packages",
        
        "Settings - Profiles": "Settings - Profiles",
        "User Management": "User Management",
        "Operation Records": "Operation Records",
        "Exit": "Exit",
        "Total pages:": "Total pages: ",
        " ": " ",
        "Go to": "Go to",
        "Prev": "Prev",
        "Next": "Next",
        "per page": "per page",
        "items": "items",
        "Please enter the page number to go to": "Please enter the page number to go to",
        "Profile": "Profile",
        "Language": "Language",
        "Please Enter your x": "Please Enter your {param}",
        "Select the x": "Select the {param}",
        "Profile Picture": "Profile Picture",
        "Old Password": "Old Password",
        "New Password": "New Password",
        "Confirm Password": "Confirm Password",
        "The two passwords entered do not match": "The two passwords entered do not match",
        "Enter the new password again": "Enter the new password again",
        "This must match the new password above": "This must match the new password above",
        "Invalid input。Password length must be 8–16 characters": "Invalid input. Password length must be 8-16 characters.",
        "Lenovo Privacy Statement": "Lenovo Privacy Statement",
        "Lenovo Software License Agreement": "Lenovo Software License Agreement",
        "Third-Party Notice": "Third-Party Notice",
        "Third-party notifications": "Third-party notifications",
        "Change Password": "Change Password",
        "Edit Profile": "Edit Profile",
        "Exited successfully": "Exited successfully",
        "Admin": "Admin",
        "Common user": "Common user",
        "Super Admin":"Super Admin",
        "Model": "Model",
        "Are you sure you want to delete this?": "Are you sure you want to delete this?",
        "Enter a new password。It must include at least three of the following：uppercase letters，lowercase letters，numbers，and special characters": "Enter a new password.It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters",
        "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters": "It must include at least three of the following: uppercase letters, lowercase letters, numbers, and special characters",
        "Tip": "Tip",
        "Confirm": "Confirm",
        "Cancel": "Cancel",
        "Deletion successful": "Deletion successful",
        "Password changed successfully": "Password changed successfully",
        "Please select the correct file type x": "Please select the correct file type {param}",
        "The file to upload is larger than 100 MB。 Please select another one。": "The file to upload is larger than 100 MB. Please select another one.",
        "Your session has expired。 Please log in again。": "Your session has expired. Please log in again.",
        "Invalid network request URL.": "Invalid network request URL.",
        "Unknown server error.": "Unknown server error.",
        "An unknown error has occurred": "An unknown error has occurred!",
        "Request timeout。 Please check your network and try again。": "Request timeout. Please check your network and try again.",
        "Invalid request header!": "Invalid request header!",
        "Illegal request header!": "Illegal request header!",
        "Failed to connect to server": "Failed to connect to server",
        "Your network may be currently disconnected": "Your network may be currently disconnected",
        "No related device found": "No related device found",
        "Pre-upgrade component not found in the device": "Pre-upgrade component not found in the device",
        "FWID of the installation component not found": "FWID of the installation component not found",
        "Failed to set upgrade information": "Failed to set upgrade information",
        "Failed to set specified update options": "Failed to set specified update options",
        "Failed to install the update package": "Failed to install the update package",
        "Failed to obtain the device handle": "Failed to obtain the device handle",
        "Upgrade device mismatch": "Upgrade device mismatch",
        "Installation failed: Pre-upgrade component not found in the device": "Installation failed: Pre-upgrade component not found in the device",
        "Installation failed: FWID mismatch in the component list": "Installation failed: FWID mismatch in the component list",
        "Installation failed: No matching monitor found for upgrade": "Installation failed: No matching monitor found for upgrade",
        "The monitor does not exist": "The monitor does not exist",
        "The command has been sent": "The command has been sent",
        "The group does not exist": "The group does not exist",
        "The command does not exist": "The command does not exist",
        "Setting does not exist": "Setting does not exist",
        "The settings profile does not exist": "The settings profile does not exist",
        "The update package does not exist": "The update package does not exist",
        "The update package record does not exist": "The update package record does not exist",
        "Invalid password format. It must be between 8 and 30 characters long.": "Invalid password format. It must be between 8 and 30 characters long.",
        "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters": "Password format is incorrect, password must include at least three types of the following: uppercase letters, lowercase letters, digits, and special characters",
        "The field is empty": "The field is empty",
        "Update time cannot be null": "Update time cannot be null",
        "Invalid update time. It cannot be earlier than the current time or more than 30 days in the future.": "Invalid update time. It cannot be earlier than the current time or more than 30 days in the future.",
        "Uploaded file is null": "Uploaded file is null",
        "Uploaded file format is incorrect， file format can only be zip/exe/dmg/app": "Uploaded file format is incorrect, file format can only be zip/exe/dmg/app",
        "Uploaded file format is incorrect， file cannot have no extension": "Uploaded file format is incorrect, file cannot have no extension",
        "The file is too large and can not exceed": "The file is too large and can not exceed",
        "The file is too large and can not exceed 500MB": "The file is too large and can not exceed 500MB",
        "The file is too large and can not exceed 400MB": "The file is too large and can not exceed 400MB",
        "The file is too large and can not exceed 300MB": "The file is too large and can not exceed 300MB",
        "The file is too large and can not exceed 200MB": "The file is too large and can not exceed 200MB",
        "The file is too large and can not exceed 100MB": "The file is too large and can not exceed 100MB",
        "Login failed。 Make sure you entered the correct account ID and password。": "Login failed. Make sure you entered the correct account ID and password.",
        "Date": "Date",
        "Time": "Time",
        "Please select an item to delete first": "Please select an item to delete first",
        "Begin Download": "Begin Download",
        "Start Download":"Start Download",
        "Password incorrect": "Password incorrect",
        "Password Changed Successfully": "Password Changed Successfully",
        "Display ID or Group ID is empty": "Display ID or Group ID is empty",
        "Select the update package": "Select the update package",
        "Username already exists": "Username already exists",
        "Executing monitor setting command。Please wait 10s before making new changes。": "Executing monitor setting command. Please wait 10s before making new changes.",
        "Close": "Close",
        "Role does not exist。 Cannot modify role。": "Role does not exist. Cannot modify role.",
        "Unknown Command": "Unknown Command",
        "Access Token Expired": "Access Token Expired",
        "Invalid Refresh Token": "Invalid Refresh Token",
        "Missing Request Parameters:": "Missing Request Parameters:",
        "Incorrect Request Parameter Type:": "Incorrect Request Parameter Type:",
        "Request URL Not Found:": "Request URL Not Found:",
        "Incorrect Request Method:": "Incorrect Request Method:",
        "Log In": "Log In",
        "account ID": "account ID",
        "password": "password",
        "Update failed": "Update failed",
        "Reset Password?": "Reset Password?",
        "Logged in successfully": "Logged in successfully",
        "Please contact the system administrator to reset your password": "Please contact the system administrator to reset your password.",
        "Retry limit exceeded。 Please try again after 30 minutes": "Retry limit exceeded. Please try again after 30 minutes",
        "Enter the model / host name / firmware version number": "Enter the model / host name / firmware version number",
        "New Group": "New Group",
        "Delete Group": "Delete Group",
        "Display Columns": "Display Columns",
        "Collapse": "Collapse",
        "Expand": "Expand",
        "Move To": "Move To",
        "Export": "Export",
        "Power On": "Power On",
        "Power Off": "Power Off",
        "Screen lock": "Screen lock",
        "Unlock screen": "Unlock screen",
        "Settings": "Settings",
        "Export Settings Profiles": "Export Settings Profiles",
        "Update": "Update",
        "Delete Monitor": "Delete Monitor",
        "Total devices": "Total devices",
        "Selected devices": "Selected devices",
        "Update package name": "Update package name",
        "Update Time": "Update Time",
        "Apply to all displays of the same model": "Apply to all displays of the same model",
        "Display Settings": "Display Settings",
        "Select All": "Select All",
        "Settings Profiles": "Settings Profiles",
        "Filename": "Filename",
        "Group": "Group",
        "Monitor Model": "Monitor Model",
        "Special ID": "Special ID",
        "Host Name": "Host Name",
        "Host Status": "Host Status",
        "Monitor Status": "Monitor Status",
        "Lock Status": "Lock Status",
        "Update Progress": "Update Progress",
        "Settings Profile": "Settings Profile",
        "Tips": "Tips",
        "Active Time": "Active Time",
        "Overclock": "Overclock",
        "Operation successful": "Operation successful",
        "Please save data": "Please save data",
        "Select the data first": "Select the data first",
        "Cannot modify when ungrouped": "Cannot modify when ungrouped",
        "Deselect All": "Deselect All",
        "Select the GAMMA node label value": "Select the GAMMA node label value",
        "Ungrouped": "Ungrouped",
        "Offline": "Offline",
        "Online": "Online",
        "Power on": "Power on",
        "Power off": "Power off",
        "Locked": "Locked",
        //"Open": "Open",
        "Open": "Unlocked",
        "Unlocked":"Unlocked",
        "Not connected": "Not connected",
        "Connected": "Connected",
        "Set the update start time": "Set the update start time",
        "Now": "Now",
        "Set upgrade mode": "Set upgrade mode",
        "Interactive Mode": "Interactive Mode",
        "Silent mode": "Silent mode",
        "In this mode， a monitor firmware update screen appears and requests confirmation to proceed。Users may choose to postpone the update twice，after which the update is mandatory。": "In this mode, a monitor firmware update screen appears and requests confirmation to proceed. Users may choose to postpone the update twice,after which the update is mandatory.",
        "In this mode， when the monitor is online， the firmware update will be automatically performed in the background。 Users will not see any notifications。 The update will take effect when the display is restarted。 The restart of the monitor takes about a few seconds， and won’t affect any ongoing tasks on your computer。":"In this mode, when the monitor is online, the firmware update will be automatically performed in the background. Users will not see any notifications. The update will take effect when the monitor is restarted. The restart of the monitor takes a few seconds, and won't affect any ongoing tasks on your computer.",
        "Invalid input": "Invalid input",
        "Failed to log in": "Failed to log in",
        "Select your preferred restart time。": "Select your preferred restart time.",
        "You have still selected the group that the device currently belongs to。 If you want to move the device， please select another group。": "Keep the devices within the target group in their current positions without moving them.",
        "Enter the group name": "Enter the group name",
        "Apply profile:": "Apply profile:",
        "A new version is available": "A new version is available",
        "Restart monitor immediately after update": "Restart monitor immediately after update",
        "Restart when the monitor enters sleep mode": "Restart when the monitor enters sleep mode",
        "Restart monitor when it disconnected from all PCs": "Restart monitor when it disconnected from all PCs",
        "Enter the model name": "Enter the model name",
        "Create Update Task": "Create Update Task",
        "Update Task List": "Update Task List",
        "Cancel All": "Cancel All",
        "View Details": "View Details",
        "Update Details": "Update Details",
        "Update Mode": "Update Mode",
        "Update Creation Time": "Update Creation Time",
        "Update Start Time": "Update Start Time",
        "Are you sure you want to cancel all tasks?": "Are you sure you want to cancel all tasks?",
        "Are you sure you want to cancel this task?": "Are you sure you want to cancel this task?",
        "Are you sure you want to delete the selected monitor?": "Are you sure you want to delete the selected monitor?",
        "Confirm to delete all displays?": "Confirm to delete all displays?",
        "You have not selected the monitor to delete。 Please check the monitor in the table!": "You have not selected the monitor to delete. Please check the monitor in the table!",
        "Are you sure you want to delete this？（Cannot delete when ungrouped）": "Are you sure you want to delete this?(Cannot delete \"Ungrouped\")",
        "Tip: If an option in the display settings appears grayed out, it may be restricted by another setting. Try adjusting other settings to remove the restriction.": "Tip: If an option in the display settings appears grayed out, it may be restricted by another setting. Try adjusting other settings to remove the restriction.",
        "The WebSocket connection has been lost Reconnecting": "The WebSocket connection has been lost. Reconnecting...",
        "The WebSocket connection has been restored": "The WebSocket connection has been restored.",
        "The previous setting is currently being applied。 Please wait until the value changes before making any new settings。": "The previous setting is currently being applied. Please wait until the value changes before making any new settings.",
        "Please copy this password into the input box: ": "Please copy this password into the input box: ",
        "Ebook": "Ebook",
        "Largest": "Largest",
        "Max":"Max",
        "Turn off auto mode": "Turn off auto mode",
        "Minimum": "Minimum",
        "Restore Factory Settings": "Restore Factory Settings",
        "Scenario Mode": "Scenario Mode",
        "Color Gamut & Color Temperature": "Color Gamut & Color Temperature",
        "Color adjustment-red": "Color adjustment-red",
        "Color adjustment-green": "Color adjustment-green",
        "Color adjustment-blue": "Color adjustment-blue",
        "Panel Native": "Panel Native",
        "Neutral": "Neutral",
        "Warm": "Warm",
        "Cool": "Cool",
        "Low Blue Light": "Low Blue Light",
        "Custom 1": "Custom 1",
        "Custom 2": "Custom 2",
        "Custom 3": "Custom 3",
        "Bluish(9300K)": "Cool",
        "Neutral(7500K)": "Neutral",
        "Reddish(6500K)": "Warm",
        "BT.709": "BT.709",
        "BT.2020": "BT.2020",
        "Video Signal": "Video Signal",
        "Game Mode": "Game Mode",
        "Off": "Off",
        "Game 1": "Game 1",
        "Game 2": "Game 2",
        "Response Time": "Response Time",
        "Normal": "Normal",
        "Extreme": "Extreme",
        "Level 1": "Level 1",
        "Level 2": "Level 2",
        "Level 3": "Level 3",
        "Level 4": "Level 4",
        "Level 5": "Level 5",
        "Lan Indicator": "Lan Indicator",
        "Linked": "Linked",
        "No Link": "No Link",
        "Blinking": "Blinking",
        "Brightness": "Brightness",
        "Contrast": "Contrast",
        "Smart Light": "Smart Light",
        "Volume Control": "Volume Control",
        "USB Select": "USB Select",
        "DP Select": "DP Select",
        "Aspect Ratio": "Aspect Ratio",
        "Smart Traffic Light": "Smart Traffic Light",
        "daisy chain": "daisy chain",
        "Dynamic Contrast": "Dynamic Contrast",
        "Smart Energy": "Smart Energy",
        "Smart Audio": "Smart Audio",
        "Distance Warning": "Distance Warning",
        "Ambient Light Detection": "Ambient Light Detection",
        "Enabled Ambient Light Detection": "Enabled Ambient Light Detection",
        "enabled":"enabled",
        "disabled":"disabled",
        "Waken on Touch": "Waken on Touch",
        "True Split": "True Split",
        "Face Tracking": "Face Tracking",
        "Audio Smart Switch": "Audio Smart Switch",
        "Auto-alarm": "Auto-alarm",
        "KVM Switch": "KVM Switch",
        "KVM切换": "KVM Switch",
        "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.": "KVM(Keyboard, Video, Mouse) Switch enables two PCs to use one set of monitor, keyboard and mouse, Enable switching video, keyboard and mouse simultaneously. If disabled, only switch keyboard and mouse.",
        "KVM(Keyboard,Video, Mouse)Switch enables two PCs to use oneset of monitor, keyboard andmouse, Enable switching video,keyboard and mousesimultaneously. if disabled, onlyswitch keyboard and mouse.":"KVM(Keyboard,Video, Mouse)Switch enables two PCs to use oneset of monitor, keyboard andmouse, Enable switching video,keyboard and mousesimultaneously. if disabled, onlyswitch keyboard and mouse.",
        "Sitting Reminder": "Sitting Reminder",
        "Gaming": "Gaming",
        "RGB Gain": "RGB Gain",
        "Serial No": "Serial No.",
        "Firmware Version": "Firmware Version",
        "Select response time level": "Select response time level",
        "Enable daisy chain": "Enable daisy chain",
        "Smart Traffic Light is a do not disturb light, helping to reduce distraction": "Smart Traffic Light is a do not disturb light, helping to reduce distraction",
        "Enable/Disable the Audio Smart function": "Enable/Disable the Audio Smart function",
        "Auto-alarm indicates whether the camera/MIC on monitor is in use": "Auto-alarm indicates whether the camera/MIC on monitor is in use",
        "Enable Distance Warning": "Enable Distance Warning",
        "Enable/disable face tracking": "Enable/disable face tracking",
        "Enable Sitting Reminder": "Enable Sitting Reminder",
        "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity": "Smart Audio technology allows you to focus on the sound in front of you to improve voice clarity",
        "Smart Energy technology automatically manages energy consumption by human detection sensor": "Smart Energy technology automatically manages energy consumption by human detection sensor",
        "Implement PBP through only one cable": "Implement PBP through only one cable",
        "Enable/Disable vPro technology in the monitor": "Enable/Disable vPro technology in the monitor",
        "Wake system by touch": "Wake system by touch",
        "Set video source and USB source (used by keyboard and mouse) for every PC": "Set video source and USB source (used by keyboard and mouse) for every PC",
        "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse": "eKVM gives you instant access over two PC sources with a 2-button pressing of your mouse",
        "Enable USB charging always on": "Enable USB charging always on",
        "Select DP version": "Select DP version",
        "USB Charging": "USB Charging",
        "PC": "PC",
        "Double-click the CTRL": "Double-click the CTRL",
        "Full Screen": "Full Screen",
        "Original AR": "Original AR",
        "No scaling": "No scaling",
        "On": "On",
        "on": "On",
        "Keyboard On": "Keyboard On",
        "Mouse On": "Mouse On",
        "Image Creation": "Image Creation",
        "Digital Cinema": "Digital Cinema",
        "Video Creation": "Video Creation",
        "Web Browsing": "Web Browsing",
        "Professional Image": "Professional Image",
        "DisplayPort": "DisplayPort",
        "Auto": "Auto",
        "auto": "Auto",
        "Refresh": "Refresh",
        "Search": "Search",
        "Record": "Record",
        "Username": "Username",
        "Upload Time": "Upload Time",
        "Add Profiles": "Add Profiles",
        "Latest Update Package": "Latest Update Package",
        "Upload Update Package": "Upload Update Package",
        "Upload": "Upload",
        "Size": "Size",
        "Upload successful": "Upload successful",
        "The file name contains illegal characters": "The file name contains illegal characters",
        "Download successful": "Download successful",
        "Refresh successful": "Refresh successful",
        "The upgrade package does not match the device model": "The upgrade package does not match the device model",
        "Upgrade package does not match the device model":"Upgrade package does not match the device model",
        "Please enter the setting name": "Please enter the setting name",
        "Edit": "Edit",
        "Save": "Save",
        "Delete": "Delete",
        "Add": "Add",
        "Reset Password": "Reset Password",
        "No": "No.",
        "Full Name": "Full Name",
        "Role": "Role",
        "Creation Date": "Creation Date",
        "Operation": "Operation",
        "Actions": "Actions",
        "The user's initial password is ": "The user's initial password is ",
        "The password has been reset to：": "The password has been reset to： ",
        "Invalid input。Usernames can only contain numbers and letters。": "Invalid input. Usernames can only contain numbers and letters.",
        "Invalid input。The username must contain 4 to 30 characters。": "Invalid input. The username must contain 4 to 30 characters.",
        "Installation Package": "Installation Package",
        "Operation Date": "Operation Date",
        "Actions": "Actions",
        "Operator": "Operator",
        "Paging component": "Paging component",
        "Quick page flipping": "Quick page flipping",
        "Current page": "Current page",
        "Title": "Title",
        "Details": "Details",
        "This is the expanded area": "This is the expanded area",
        "Set Display Column": "Set Display Column",
        "Upload file": "Upload file",
        "Drop-down to expand": "Drop-down to expand",
        "Default": "Default",
        "Default Info": "Default Info",
        "Personal Center": "Personal Center",
        "Personal center image button": "Personal center image button",
        "Expandable area": "Expandable area",
        "Update Package Table": "Update Package Table",
        "This is the table header": "This is the table header",
        "This is the table content": "This is the table content",
        "UserList Table": "UserList Table",
        "Page Up and Down": "Page Up and Down",
        "Operation record table": "Operation record table",
        "OSD upgrade details": "OSD upgrade details",
        "Lenovo": "Lenovo",
        "Display Fleet Manager": "Display Fleet Manager",
        "HDR": "HDR",
        "eKVM": "eKVM",
        "Video": "Video",
        "Data": "Data",
        "vPro": "vPro",
        "Gama": "Gama",
        "PIP/PBP": "PIP/PBP",
        "OSD": "OSD",
        "USB-C Charging": "USB-C Charging",
        "PIP": "PIP",
        "PBP": "PBP",
        "Close PIP, PBP":"Close",
        "PIP window":"PIP",
        "PBP window":"PBP",
        /*
        "Simplified Chinese": "Simplified Chinese",
        "English": "English",
        "Traditional Chinese": "Traditional Chinese",
        "French": "French",
        "German": "German",
        "Italian": "Italian",
        "Spanish": "Spanish",
        "Japanese": "Japanese",
        "Thai": "Thai",
        "Ukrainian": "Ukrainian",
        "Russian": "Russian",
        */
        "Enter your account ID": "Enter your account ID",
        "Please Enter your account id":"Please contact the system administrator to reset your password",
        "Enter your password": "Enter your password",
        "Cannot exceed 20 characters": "Cannot exceed 20 characters",
        "Enter the original password": "Enter the original password",
        "You have still selected the group that the device currently belongs to。 If you want to move the device, please select another group。": "You have still selected the group that the device currently belongs to. If you want to move the device, please select another group. ",
        "Enter the filename": "Enter the filename",
        "Update Package Name": "Update Package Name",
        "Select the date": "Select the date",
        "Select the time": "Select the time",
        "Set the update mode": "Set the update mode",
        "Restart when the monitor is not connected to any computer": "Restart when the monitor is not connected to any computer",
        "Invalid file format": "Invalid file format, Only zip/exe/dmg/app files are supported.",
        "Select a valid file type": "Select a valid file type",
        "The data will be permanently deleted":"The data will be permanently deleted. Do you want to continue?",
        "The data is being processed。 Please do not submit again。": "The data is being processed. Please do not submit again.",
        "Enter the profiles name": "Enter the profiles name",
        "Enter your username": "Enter your username",
        "Enter your full name": "Enter your full name",
        "The initial password of this user is:": "The initial password of this user is:",
        "Select your role": "Select your role",
        "User Profile": "User Profile",
        "Downloading": "Downloading...",
        "Enter the new password again。Two times of new password input is same": "Enter the new password again.Two times of new password input is same",
        "Request failed with status code 502": "Request failed with status code 502",
        "Input characters within x characters": "Input characters within {param} characters",

        "Monitor List":"Monitor List",
        "Installation Package List":"Installation Package List",
        "Update Package":"Update Package",
        "Settings - Profiles":"Settings - Profiles",
        "User Management":"User Management",
    

        "Simplified Chinese": "简体中文",
        "English": "English",
        "Traditional Chinese": "繁體中文",
        "French": "Français",
        "German": "Deutsch",
        "Italian": "Italiano",
        "Spanish": "Español",
        "Japanese": "日本語",
        "Thai": "ภาษาไทย",
        "Ukrainian": "Українська",
        "Russian": "Русский язык",

        "System abnormality":"System abnormality",

        "Upgrade Package Record ID is empty":"Select the update package",

        "Invalid update time。 It cannot be earlier than the current time or more than 30 days in the future。":"Invalid update time. It cannot be earlier than the current time or more than 30 days in the future.",
        "Request parameter is invalid：The username must contain 4 to 30 characters。":"Invalid input. The username must contain 4 to 30 characters.",
        "Request parameter is invalid：Usernames can only contain numbers and letters。":"Request parameter is invalid:Usernames can only contain numbers and letters.",


        "The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling":"The compiled package is missing: the component has a corresponding bin that has not been uploaded。Please upload it before compiling",


        "Request parameter is invalid：Password length must be 8-16 characters":"Request parameter is invalid: Password length must be 8-16 characters",


        "Tip: If an option in the display settings appears grayed out， it may be restricted by another setting。 Try adjusting other settings to remove the restriction。": "Tip: If an option in the display settings appears grayed out, it may be restricted by another setting. Try adjusting other settings to remove the restriction.",

        "Illegal request header!": "Illegal request header!",


        "Invalid request parameters":"Invalid request parameters",

        "It is already a high-version and there is no need to upgrade":"It is already a high-version and there is no need to upgrade",
        "Repeated request， please try again later":"Repeated request, please try again later",
        "Communication":"Communication",
    }
}